import { createFileRoute } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { ComputedProductStatus, ProductSortField, SortingOrder } from "@/graphql/codegen/graphql"
import ProductListContainer from "@/screens/Products/containers/ProductListContainer"

const SearchParamsValidator = z.object({
  query: fallback(z.string().optional().default(""), "").optional(),
  field: fallback(z.nativeEnum(ProductSortField), ProductSortField.ProductSupplierDescription),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
  computedProductStatuses: z.array(z.nativeEnum(ComputedProductStatus)).optional(),
  companyIds: z.array(z.string()).optional(),
})

export const Route = createFileRoute("/app/products/")({
  validateSearch: SearchParamsValidator.parse,
  component: ProductListContainer,
})
